import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Watermark, Eyebrow } from "../components/Botanical";

const TABS = [
  { key: "research", label: "Research Catalog", note: "Research use only. Not for human or animal consumption.", empty: "Our research catalog is coming soon." },
  { key: "skincare", label: "Skincare", note: "Topical cosmetic serums from Kind of Crunchy Moms.", empty: "Our serums are coming soon." },
];

const useCategory = (category) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/products", { params: { category } }).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [category]);
  return items;
};

export default function Home() {
  const [params, setParams] = useSearchParams();
  const active = params.get("tab") === "skincare" ? "skincare" : "research";
  const lists = { research: useCategory("research"), skincare: useCategory("skincare") };
  const tab = TABS.find((t) => t.key === active);
  const items = lists[active];

  return (
    <div className="relative overflow-x-clip" data-testid="home-catalog">
      <Watermark opacity={0.6} height="h-[250px] sm:h-[290px]" testid="home-watermark" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-12 sm:py-16">
        <Eyebrow>Kind of Crunchy Moms</Eyebrow>
        <h1 className="font-serif text-4xl sm:text-5xl mt-2" data-testid="catalog-heading">Product Catalog</h1>

        <div role="tablist" aria-label="Product categories" className="mt-8 inline-flex rounded-full border border-[#D8CDBC] bg-white p-1">
          {TABS.map((t) => (
            <button
              key={t.key}
              role="tab"
              aria-selected={active === t.key}
              onClick={() => setParams(t.key === "research" ? {} : { tab: t.key }, { replace: true })}
              data-testid={`catalog-tab-${t.key}`}
              className={`px-5 sm:px-6 py-2 rounded-full text-sm transition-colors ${active === t.key ? "bg-[#59394F] text-[#F4EBDD]" : "text-[#5A433B] hover:bg-[#59394F]/10"}`}
            >
              {t.label}
            </button>
          ))}
        </div>
        <p className="text-sm text-[#5E4D5A] mt-4" data-testid="catalog-note">{tab.note}</p>

        <div className="mt-8" role="tabpanel" data-testid={`catalog-panel-${active}`}>
          {items && items.length === 0 && (
            <div className="text-center py-20 rounded-2xl border border-dashed border-[#A8B59A] text-[#5E4D5A]" data-testid="catalog-empty">
              {tab.empty}
            </div>
          )}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {(items || []).map((p) => <ProductCard key={p.id} product={p} skincare={active === "skincare"} />)}
          </div>
        </div>
      </div>
    </div>
  );
}
